import { useQuery } from 'react-query';
import { useSetRecoilState } from 'recoil';

import { createHttpClient } from '@api/http-client';
import { END_POINTS } from '@constants/api-endpoints';
import { QUERY_KEYS } from '@constants/query-keys';
import { AlertType } from '@enums/alert';
import { showAlert } from '@lib/alert/alert-manager';
import { Workspace } from '@pages/select-workspace/types';
import { workspaceAtom } from '@store/atoms/workspace';

export const useGetWorkspace = ({ enabled }: { enabled: boolean }) => {
  const client = createHttpClient();

  const setCurrentWorkspace = useSetRecoilState(workspaceAtom);

  const query = useQuery(
    QUERY_KEYS.WORKSPACE.GET_CURRENT_WORKSPACE,
    () => {
      return client<Workspace>({
        url: END_POINTS.WORKSPACE.BASE_WORKSPACE,
      });
    },
    {
      retry: 0,
      enabled,
      onSuccess: data => {
        setCurrentWorkspace(data);
      },
      onError: (error: Error) => {
        showAlert({
          type: AlertType.ERROR,
          header: 'Failed to fetch workspace details',
          message: `${error?.message || 'Request failed'}`,
        });
      },
    },
  );

  return query;
};
